// Copyright (c) 2025 Greener Power Solutions.
// This file is part of Greener Power Solutions' software,
// and may not be altered, copied, redistributed, or sold
// without specific permission.

const defaultStyles = {
  fontFamily: '"Source Sans 3 Variable"',
  fontStyle: 'normal',
  buttonSmall: {
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '0.15px',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  buttonMedium: {
    fontSize: '16px',
    lineHeight: '16px',
    letterSpacing: '0.2px',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  buttonLarge: {
    fontSize: '20px',
    lineHeight: '20px',
    letterSpacing: '0.3px',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  h1: {
    fontSize: '32px',
    lineHeight: 1.19,
    letterSpacing: '-0.2px',
    fontWeight: 600,
  },
  h2: {
    fontSize: '24px',
    lineHeight: 1.17,
    letterSpacing: '0px',
    fontWeight: 600,
  },
  h3: {
    fontSize: '20px',
    lineHeight: 1.2,
    letterSpacing: '0px',
    fontWeight: 600,
  },
  h4: {
    fontSize: '18px',
    lineHeight: 1.11,
    letterSpacing: '0px',
    fontWeight: 600,
  },
  subtitle1: {
    fontSize: '18px',
    lineHeight: 1.56,
    letterSpacing: '0px',
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: '14px',
    lineHeight: 1.43,
    letterSpacing: '0px',
    fontWeight: 600,
  },
  body1: {
    fontSize: '16px',
    lineHeight: 1.5,
    letterSpacing: '0px',
    fontWeight: 400,
  },
  body2: {
    fontSize: '14px',
    lineHeight: 1.43,
    letterSpacing: '0px',
    fontWeight: 400,
  },
  caption: {
    fontSize: '12px',
    lineHeight: 1.33,
    letterSpacing: '0.1px',
    fontWeight: 400,
  },
  overline: {
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: 1.2,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
  },
};

export default defaultStyles;
